import TaTransactionExporter from './TaTransactionExporter'

export default TaTransactionExporter
